import React from 'react';
import TaxBillColAndPayInfo from '../../components/taxbillmng/TaxBillColAndPayInfo';

const TaxBillColAndPayContainer = ({taxbill}) => {
  return <TaxBillColAndPayInfo taxbill={taxbill}/>
};

export default TaxBillColAndPayContainer;
